function whatyouget() {
    $(".features-nav a").on('click', function(e) {
        var $this = $(this),
            $nav = $this.closest('.features-nav'),
            href = $this.attr('href');

        e.preventDefault();

        $nav.find('li').removeClass('active');
        $this.parent().addClass('active');

        POP.scrollTo(href, true, true);
    });
    $('#popLink').on('click' , function(e){
        POP.scrollTo("#start-page", true, true);
    });
    

    $("#dns-switcher").on('click', function(e){
		$("#simple-dns").fadeToggle();
		$("#advanced-dns").fadeToggle();
    });
}
